import {Button, Icon, clx} from '@hm/fundamental'
import {mdiCursorDefaultClickOutline, mdiCursorMove} from '@mdi/js'
import {useTranslation} from 'react-i18next'

import {StaticPartInteractionModesEnum} from '@refra/modules/refra-static-parts/enums'
import {useEditReplacement} from '@refra/modules/refra-static-parts/providers'

export const DrawingInteractionControls = () => {
  const {t} = useTranslation()
  const {interactionMode, setInteractionMode} = useEditReplacement()

  return (
    <div className="flex gap-1 rounded-lg border border-gray-100 bg-white p-1 shadow-md">
      <Button
        variant={interactionMode === StaticPartInteractionModesEnum.MOVE ? 'tertiary' : 'secondary'}
        onClick={() => setInteractionMode(StaticPartInteractionModesEnum.MOVE)}
        className={clx(
          'flex items-center gap-2 rounded-md px-3 py-1.5 text-sm font-semibold transition-all border-none',
          interactionMode === StaticPartInteractionModesEnum.MOVE
            ? 'bg-blue-50 text-blue-600'
            : 'text-gray-500 hover:bg-gray-50'
        )}
      >
        <Icon
          path={mdiCursorMove}
          customSize={0.8}
          className={clx(
            interactionMode === StaticPartInteractionModesEnum.MOVE
              ? 'text-blue-600'
              : 'text-gray-600'
          )}
        />
        {t('staticParts.editReplacement.mode.move')}
      </Button>
      <Button
        variant={
          interactionMode === StaticPartInteractionModesEnum.SELECT ? 'tertiary' : 'secondary'
        }
        onClick={() => setInteractionMode(StaticPartInteractionModesEnum.SELECT)}
        className={clx(
          'flex items-center gap-2 rounded-md px-3 py-1.5 text-sm font-semibold transition-all border-none',
          interactionMode === StaticPartInteractionModesEnum.SELECT
            ? 'bg-blue-50 text-blue-600'
            : 'text-gray-500 hover:bg-gray-50'
        )}
      >
        <Icon
          path={mdiCursorDefaultClickOutline}
          customSize={0.8}
          className={clx(
            interactionMode === StaticPartInteractionModesEnum.SELECT
              ? 'text-blue-600'
              : 'text-gray-600'
          )}
        />
        {t('staticParts.editReplacement.mode.select')}
      </Button>
    </div>
  )
}
